class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  constructor() { 
    super();
    this.collectionProdAtc = this.querySelectorAll('.cdc__prod-atc') || null;
    if (this.collectionProdAtc != null) { 
      this.collectionProdAtc.forEach(btn => btn.addEventListener('click', this.addCollectionProd.bind(this, btn)))
    }
  }

  addCollectionProd(btn) { 
    const body = JSON.stringify({
      id: Number(btn.dataset.id),
      quantity: 1,   
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    });
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        console.log(response.description);
      }
      
      const cartDrawer = response.sections['cart-drawer'];
      const cartCount = response.sections['cart-icon-bubble'];
      // Replace cart drawer
      const cartDrawerdestination = document.querySelector(`#CartDrawer .drawer__inner`);
      const cartDrawerSource = new DOMParser().parseFromString(cartDrawer, 'text/html').querySelector('#CartDrawer .drawer__inner').innerHTML;      
      if (cartDrawerSource && cartDrawerdestination) cartDrawerdestination.innerHTML = cartDrawerSource;

      // Replace cart icon bubble
      const cartIconBubbledestination = document.getElementById(`cart-icon-bubble`);
      const cartIconBubbleSource = new DOMParser().parseFromString(cartCount, 'text/html').querySelector('#shopify-section-cart-icon-bubble').innerHTML;
      if (cartIconBubbleSource && cartIconBubbledestination) cartIconBubbledestination.innerHTML = cartIconBubbleSource;      
    })
    .catch((error) => {
      console.error('Error:', error);
    })
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: ['.drawer__inner']
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: ['.shopify-section']
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
